export default __webpack_public_path__ + "static/media/homeBijoux8.e4afffcd.jpg";